import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "../Response/responseSlice";
import { setToast, setLoading, setModal } from "../uiSlice";
import { adminMetodologias, getMetodologias } from "Services/metodologia_educativa_service";

const initialState = {
    metodologiasEducativas: [],
    metodologiaEducativa: {
        nombre: '',
        estado: 1,
    },
}

export const metodologiaEducativaSlice = createSlice({
    name: 'metodologiaEducativa',
    initialState,
    reducers: {
        setMetodologias: (state, action) => {
            state.metodologiasEducativas = action.payload;
        },
        setMetodologia: (state, action) => {
            state.metodologiaEducativa = action.payload ?? initialState.metodologiaEducativa;
        },
    }
});

export const fetchMetodologiasEducativas = createAsyncThunk(
    'metodologiaEducativa/fetchMetodologiasEducativas',
    async (_, { dispatch }) => {
        const metodologiaRes = await getMetodologias();
        dispatch(setMetodologias(metodologiaRes));
    }
);

export const mergeMetodologia = createAsyncThunk(
    'metodologiaEducativa/merge',
    async (data, {dispatch}) => {
        dispatch(setLoading(true))
        const metodologiaRes = await adminMetodologias(data);
        dispatch(setResponse(metodologiaRes));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchMetodologiasEducativas());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setMetodologias, setMetodologia } = metodologiaEducativaSlice.actions;
export default metodologiaEducativaSlice.reducer;